import { createQueryStringToggleHook } from "../../../stores/useQueryState";
import {
  ModifiedTirePartItem,
  useTireResults,
} from "../Results/useTireResults";

export const useTireCompareIds = createQueryStringToggleHook("compare", []);

export const useTireCompareIdsWithQuickCompareFallback: typeof useTireCompareIds =
  () => {
    const { data: fallback } = useTireResults();
    const [compareIds, setCompareIds] = useTireCompareIds();

    const idsWithFallback = compareIds.length
      ? compareIds
      : getQuickCompareIds(fallback?.allParts);

    return [idsWithFallback, setCompareIds];
  };

const getQuickCompareIds = (allParts?: ModifiedTirePartItem[]): string[] => {
  if (!allParts) {
    return [];
  }
  const quick = allParts.slice(0, 3);

  const isStaggered = quick.every(
    ({ partDetails }) => partDetails.secondaryParts[0],
  );

  const ids = quick.flatMap(
    ({ partDetails }) =>
      [
        partDetails.primaryPart.itemId,
        isStaggered && partDetails.secondaryParts[0]?.itemId,
      ].filter(Boolean) as string[],
  );

  return ids;
};
